module.exports = __webpack_public_path__ + "static/media/ck.960a7b5a.svg";